export interface MultiplexBlobSegmentationChannelProfile {
  medianFilterSizeUm: number;
  threshold: number;
  openingKernelSizeUm: number;
  closingKernelSizeUm: number;
  minBlobAreaUm2: number;
  smoothingKernelSizeUm: number;
}

export interface MultiplexBlobSegmentationJobConfig {
  channelNames: string[];
  profiles: Record<string, MultiplexBlobSegmentationChannelProfile>;
  resolutionUmpp?: number | null;
  normalizationName?: string | null;
  medianFilterSizeUm?: number;
  threshold?: number;
  openingKernelSizeUm?: number;
  closingKernelSizeUm?: number;
  minBlobAreaUm2?: number;
  smoothingKernelSizeUm?: number;
}

export interface MultiplexBlobSegmentationFormValues {
  jobName: string;
  jobDescription: string;
  configParams: MultiplexBlobSegmentationJobConfig;
}

export enum RunMultiplexBlobSegmentationStep {
  LoadParams = 'Reuse Previous Job Settings',
  NameAndDescription = 'Name and Description',
  Configuration = 'Configuration',
  Advanced = 'Advanced',
}

export const runMultiplexBlobSegmentationStepsOrder = [
  RunMultiplexBlobSegmentationStep.LoadParams,
  RunMultiplexBlobSegmentationStep.NameAndDescription,
  RunMultiplexBlobSegmentationStep.Configuration,
  RunMultiplexBlobSegmentationStep.Advanced,
];

export const multiplexBlobSegmentationDefaultMedianFilterSizeUm = 0;
export const multiplexBlobSegmentationDefaultThreshold = 0.5;
export const multiplexBlobSegmentationDefaultOpeningKernelSizeUm = 5;
export const multiplexBlobSegmentationDefaultClosingKernelSizeUm = 5;
export const multiplexBlobSegmentationDefaultMinBlobAreaUm2 = 400;
export const multiplexBlobSegmentationDefaultSmoothingKernelSizeUm = 0;
